__turbopack_context__.v({
  "fullwidth": "fqTx2q_fullwidth",
  "grayscale": "fqTx2q_grayscale",
  "wrapper": "fqTx2q_wrapper",
});
